// Чистые функции над сырым ответом /engine/function/market_bets/order_book.php.
// Без DOM и без сети — единственное место, где живёт правило вывода котировок.
//
// Правило сверено на проде 2026-08-07 по всем 32 кнопкам события 20: совпало 32/32.
//   ask     = min(orders[team].sell[].price), отображается как 1, если асков нет
//   bid     = max(orders[team].buy[].price),  отображается как 0, если бидов нет
//   percent = (ask + bid) / 2 * 100, либо доступная котировка * 100, если пуста одна сторона

const OUTCOMES = ['yes', 'no'];

const toFiniteNumber = value => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const bestPrice = (orders, pick) => {
    if (!Array.isArray(orders)) return null;

    let best = null;
    orders.forEach(order => {
        const price = toFiniteNumber(order && order.price);
        if (price === null) return;
        best = best === null ? price : pick(best, price);
    });
    return best;
};

export const formatPrice = value => Number(value).toFixed(2);

// До одного знака после запятой, хвостовой ноль обрезается: 8, 9.5, 92.
export const formatPercent = value => String(Number(Number(value).toFixed(1)));

const deriveOutcome = sideOrders => {
    const ask = bestPrice(sideOrders && sideOrders.sell, Math.min);
    const bid = bestPrice(sideOrders && sideOrders.buy, Math.max);

    // Обе стороны пусты — котировки нет вовсе. Потребитель обязан пропустить исход,
    // а не записывать фолбэки: сервер для такой команды рендерит пустой bid,
    // и запись «0» разошлась бы с разметкой.
    if (ask === null && bid === null) return null;

    const percentSource = (ask !== null && bid !== null) ? (ask + bid) / 2 : (ask === null ? bid : ask);

    return {
        ask: ask === null ? '1' : formatPrice(ask),
        bid: bid === null ? '0' : formatPrice(bid),
        percent: formatPercent(percentSource * 100)
    };
};

export const deriveQuotes = payload => {
    const quotes = new Map();
    const entries = payload && Array.isArray(payload.response) ? payload.response : [];

    entries.forEach(entry => {
        if (!entry || typeof entry !== 'object') return;

        const teamId = entry.market_event_team_id;
        if (teamId === undefined || teamId === null || teamId === '') return;

        // orders может прийти пустым массивом — это реальная форма команды
        // вообще без ордеров (событие 11, команды 45 и 46).
        const orders = entry.orders && typeof entry.orders === 'object' ? entry.orders : {};
        const teamQuotes = {};
        OUTCOMES.forEach(outcome => {
            teamQuotes[outcome] = deriveOutcome(orders[outcome]);
        });

        quotes.set(String(teamId), teamQuotes);
    });

    return quotes;
};

// Пустой контейнер — реальная форма команды вообще без ордеров.
// PHP сериализует пустой ассоциативный массив в [], что и приходит по факту
// (событие 11, команды 45 и 46). Форма {} принимается наравне: семантически
// это то же самое, а завязываться на детали сериализации нельзя.
const isEmptyOrdersContainer = orders => {
    if (!orders || typeof orders !== 'object') return false;
    if ('yes' in orders || 'no' in orders) return false;
    return Array.isArray(orders) ? orders.length === 0 : Object.keys(orders).length === 0;
};

const isSideSlot = side => side === undefined || Array.isArray(side);

const isOutcomeShape = outcome => Boolean(outcome)
    && typeof outcome === 'object'
    && !Array.isArray(outcome)
    && isSideSlot(outcome.buy)
    && isSideSlot(outcome.sell);

const isNormalOrdersShape = orders => Boolean(orders)
    && typeof orders === 'object'
    && !Array.isArray(orders)
    && isOutcomeShape(orders.yes)
    && isOutcomeShape(orders.no);

export const isCompleteOrderBookPayload = (payload, expectedTeamIds) => {
    if (!payload || typeof payload !== 'object' || !Array.isArray(payload.response)) return false;

    const usableIds = new Set();

    for (const entry of payload.response) {
        if (!entry || typeof entry !== 'object') continue;

        const teamId = entry.market_event_team_id;
        if (teamId === undefined || teamId === null || teamId === '') continue;

        // Элемент заявил команду, но форма orders не та, что отдаёт бэкенд, —
        // значит ответу верить нельзя целиком.
        if (!isEmptyOrdersContainer(entry.orders) && !isNormalOrdersShape(entry.orders)) return false;

        usableIds.add(String(teamId));
    }

    if (!usableIds.size) return false;

    const expected = expectedTeamIds instanceof Set ? expectedTeamIds : new Set(expectedTeamIds || []);
    for (const id of expected) {
        if (!usableIds.has(id)) return false;
    }

    return true;
};
